import { render, staticRenderFns } from "./DesignStatusList.vue?vue&type=template&id=0e9e20c4&"
import script from "./DesignStatusList.vue?vue&type=script&lang=js&"
export * from "./DesignStatusList.vue?vue&type=script&lang=js&"
import style0 from "./DesignStatusList.vue?vue&type=style&index=0&id=0e9e20c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports